<template>
  <div>
    <v-btn
      small
      flat
      class="pa-0 ma-0"
      :disabled="disabled"
      @click="showOptions = true"
    >
      <img
        src="/flags/blank.gif"
        :class="`flag flag-${countrySelected.iso}`"
        :alt="countrySelected.nicename"
        class="pa-2"
      />
      <span class="initialize">{{ countrySelectedDisplayName }}</span>
    </v-btn>

    <wsp-modal v-if="showOptions">
      <v-card class="pb-5">
        <v-card-title class="pa-0">
          <v-toolbar class="primary" dark dense flat>
            <v-toolbar-title>
              {{ $t('global.choose.prefix') }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showOptions = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs6 v-for="c in countries" :key="c.id">
              <v-card class="ma-2" @click="onFlagChange(c)" hover>
                <v-layout row class="pa-2">
                  <v-flex xs3>
                    <v-img
                      src="/flags/blank.gif"
                      contains
                      :class="`flag flag-${c.iso}`"
                      :alt="c.nicename"
                    ></v-img>
                  </v-flex>
                  <v-flex
                    xs2
                    class="font-weight-bold grey--text text--darken-1 align-self-center text-xs-right"
                  >
                    +{{ c.phonecode }}
                  </v-flex>
                  <v-flex
                    class="align-self-center ml-2 font-weight-medium grey--text text--darken-1"
                  >
                    {{ c.nicename }}
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </wsp-modal>
  </div>
</template>

<script>
import WspModal from '@/components/commons/WspModal';
import store from '@/store';
import _ from 'lodash';

export default {
  name: 'FlagDropDown',
  components: {
    [WspModal.name]: WspModal,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      default: -1,
    },
  },
  computed: {
    countrySelectedDisplayName() {
      if (typeof this.countrySelected === 'undefined') {
        return '';
      }
      return this.getCountryDisplayName(this.countrySelected);
    },
  },
  data: function () {
    return {
      countries: [
        {
          id: 5,
          iso: 'ad',
          nicename: 'Andorra',
          phonecode: 376,
        },
        {
          id: 30,
          iso: 'br',
          nicename: 'Brazil',
          phonecode: 55,
        },
        {
          id: 43,
          iso: 'cl',
          nicename: 'Chile',
          phonecode: 56,
        },
        {
          id: 47,
          iso: 'co',
          nicename: 'Colombia',
          phonecode: 57,
        },
        {
          id: 199,
          iso: 'es',
          nicename: 'España',
          phonecode: 34,
        },
        {
          id: 138,
          iso: 'mx',
          nicename: 'México',
          phonecode: 52,
        },
        {
          id: 168,
          iso: 'pe',
          nicename: 'Peru',
          phonecode: 51,
        },
        {
          id: 172,
          iso: 'pt',
          nicename: 'Portugal',
          phonecode: 351,
        },
        {
          id: 228,
          iso: 'uy',
          nicename: 'Uruguay',
          phonecode: 598,
        },
      ],
      countrySelected: {},
      showOptions: false,
    };
  },
  created() {
    this.reset();
    if (store.state.user !== null) {
      let userPrefix = Number(store.state.user.prefix.replace('+', ''));
      let tempCountrySelected = _.find(this.countries, (it) => {
        return it.phonecode === userPrefix;
      });

      if (typeof tempCountrySelected === 'undefined') {
        userPrefix = Number(
          store.state.countrySelected.prefix.replace('+', '')
        );
        tempCountrySelected = _.find(this.countries, (it) => {
          return it.phonecode === userPrefix;
        });
      }
      if (typeof userPrefix !== 'undefined') {
        this.countrySelected = tempCountrySelected;
        this.$emit('change', this.countrySelected);
      }
    }
  },
  // Methods, we will bind these later on.
  methods: {
    getCountryDisplayName(country) {
      return `+${country.phonecode} ${country.nicename}`;
    },
    onFlagChange: function (country) {
      this.countrySelected = country;
      this.$emit('change', this.countrySelected);
      this.showOptions = false;
    },
    reset() {
      if (this.value === -1) {
        this.setDefaultStateCountry();
      } else {
        this.countrySelected = _.find(this.countries, (itCountry) => {
          return itCountry.phonecode === Number(this.value);
        });
      }

      if (typeof this.countrySelected === 'undefined') {
        this.setDefaultStateCountry();
      }
    },
    setDefaultStateCountry() {
      this.countrySelected = _.find(this.countries, (itCountry) => {
        return itCountry.iso === store.state.countrySelected.code.toLowerCase();
      });
    },
  },
};
</script>
